import React, { FC } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { IosDownloadIcon, AndroidDownloadIcon, ContinueOnWebIcon } from 'assets/svgs/led-landing';
import { StartNewProjectScreen } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";
import { PageLink } from "components/common/atoms";

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      padding: theme.spacing(14, 0),
      overflow: 'hidden',
    },

    mobileTextCenter: {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },

    button: {
      marginRight: theme.spacing(3),
      boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
      willChange: 'box-shadow',
      transition: 'box-shadow 0.2s ease',
      '&:hover': {
        boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
      },
    },

    image: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(14),
      },
    },
  };
});

const WhySwitchToLedSection: FC = () => {
  const { t } = useI18n();

  const classes = useStyles();
  const isMediumUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Box className={classes.root}>
      <Container maxWidth={false} fixed>
        <Grid
          container
          direction="row"
          justifyContent={isMediumUp ? 'space-between' : 'flex-end'}
          alignItems="center"
        >
          <Grid item lg={5} md={6} xs={12}>
            <Box mb={4}>
              <Typography variant="h2" className={classes.mobileTextCenter}>
                {t('landing.enjoy.title')}
              </Typography>
            </Box>
            <Box mb={6}>
              <Typography variant="body1" className={classes.mobileTextCenter}>
                {t('landing.enjoy.description')}
              </Typography>
            </Box>
            <Box className={classes.mobileTextCenter}>
              <PageLink
                href="https://apps.apple.com/us/app/energy5-save-on-energy/id1585125070#?platform=iphone"
                target="_blank"
                rel="noreferrer"
              >
                <IosDownloadIcon className={classes.button} />
              </PageLink>
              <PageLink
                href="https://play.google.com/store/apps/details?id=us.ussoftwaresolutions.energy5"
                target="_blank"
                rel="noreferrer"
              >
                <AndroidDownloadIcon className={classes.button} />
              </PageLink>
              <PageLink href="/lighting-retrofit/project-intro">
                <ContinueOnWebIcon className={classes.button} />
              </PageLink>
            </Box>
          </Grid>
          <Grid item lg={5} md={6} xs={10}>
            <img src={StartNewProjectScreen} alt="Download mobile app" className={classes.image} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default WhySwitchToLedSection;
